module.exports = __webpack_public_path__ + "static/media/sleep-apnoea-news.7e07d589.jpg";